import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import Header from "shared/Header/Header";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
import ListingExperiencesPage from "containers/ListingExperiencesPage/ListingExperiencesPage";
import ListingExperiencesMapPage from "containers/ListingExperiencesPage/ListingExperiencesMapPage";
import ListingStayDetailPage from "containers/ListingDetailPage/ListingStayDetailPage";
import ListingExperiencesDetailPage from "containers/ListingDetailPage/ListingExperiencesDetailPage";
import ListingCarPage from "containers/ListingCarPage/ListingCarPage";
import ListingCarMapPage from "containers/ListingCarPage/ListingCarMapPage";
import ListingCarDetailPage from "containers/ListingDetailPage/ListingCarDetailPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import AuthorPage from "containers/AuthorPage/AuthorPage";
import AccountAddressPage from "containers/AccountPage/AccountAddress";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountVerification from "containers/AccountPage/AccountVerification";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import BlogPage from "containers/BlogPage/BlogPage";
import BlogSingle from "containers/BlogPage/BlogSingleTest";
import PageAddListing1 from "containers/PageAddListing1/PageAddListing1";
import PageAddListing2 from "containers/PageAddListing1/PageAddListing2";
import PageAddListing3 from "containers/PageAddListing1/PageAddListing3";
import PageAddListing4 from "containers/PageAddListing1/PageAddListing4";
import PageAddListing5 from "containers/PageAddListing1/PageAddListing5";
import PageAddListing6 from "containers/PageAddListing1/PageAddListing6";
import PageAddListing7 from "containers/PageAddListing1/PageAddListing7";
import PageAddListing8 from "containers/PageAddListing1/PageAddListing8";
import PageAddListing9 from "containers/PageAddListing1/PageAddListing9";
import PageAddListing10 from "containers/PageAddListing1/PageAddListing10";
import VendorEntries from "containers/AccountPage/VendorEntries";
import VendorListing from "containers/AccountPage/VendorListing";
import VendorStatus from "containers/AccountPage/VendorStatus";
// import TestingPage from "containers/TestPage/TestPage";

import SnK from "containers/SnKPage";
import AuthSuccess from "containers/PageAuthSuccess";
import ListingPage from "containers/ListingPage/ListingPage";
import AccountEntries from "containers/AccountPage/AccountEntries";
import Verification from "containers/PageAuthSuccess/Verification";
import forgetPassword from "containers/ForgetPassword/forgetPassword";
import PageUpdatePassword from "containers/UpdatePassword/UpdatePassword";
import RouteChangeTracker from "components/RouteChangeTracker";
import App from "admin/src/App";

export const pages: Page[] = [
	{ path: "/", exact: true, component: PageHome },
	{ path: "/#", exact: true, component: PageHome },
	{ path: "/auth-success", component: AuthSuccess },
	{ path: "/listing-stay", component: ListingStayPage },
	{ path: "/listing-stay-map", component: ListingStayMapPage },
	{ path: "/listing-stay-detail", component: ListingStayDetailPage },
	//
	{
		path: "/listing-experiences",
		component: ListingExperiencesPage,
	},
	{
		path: "/listing-experiences-map",
		component: ListingExperiencesMapPage,
	},
	{
		path: "/listing-experiences-detail",
		component: ListingExperiencesDetailPage,
	},
	//
	// * listing
	{ path: "/listing-car", component: ListingCarPage },
	{ path: "/listing-car-map", component: ListingCarMapPage },
	{ path: "/listing", exact: true, component: ListingPage },
	{ path: "/listing/:id", component: ListingCarDetailPage },

	// { path: "/listing-car-detail", component: ListingCarDetailPage },
	//
	{ path: "/checkout", component: CheckOutPage },
	{ path: "/transaction/:id", component: PayPage },
	//
	{ path: "/user/:id", component: AuthorPage },
	{ path: "/account", component: AccountPage },
	{ path: "/account-address", component: AccountAddressPage },
	{ path: "/account-password", component: AccountPass },
	{ path: "/account-savelists", component: AccountSavelists },
	{ path: "/account-verification", component: AccountVerification },
	//
	{ path: "/blog/:id", component: BlogSingle },
	{ path: "/blog", component: BlogPage },

	//
	{ path: "/add-listing-1", component: PageAddListing1 },
	{ path: "/add-listing-2", component: PageAddListing2 },
	{ path: "/add-listing-3", component: PageAddListing3 },
	{ path: "/add-listing-4", component: PageAddListing4 },
	{ path: "/add-listing-5", component: PageAddListing5 },
	{ path: "/add-listing-6", component: PageAddListing6 },
	{ path: "/add-listing-7", component: PageAddListing7 },
	{ path: "/add-listing-8", component: PageAddListing8 },
	{ path: "/add-listing-9", component: PageAddListing9 },
	{ path: "/add-listing-10", component: PageAddListing10 },
	//
	{ path: "/contact", component: PageContact },
	{ path: "/about", component: PageAbout },
	{ path: "/signup", component: PageSignUp },
	{ path: "/login", component: PageLogin },
	{ path: "/subscription", component: PageSubcription },
	{ path: "/snk", component: SnK },
	{ path: "/verification/:message", component: Verification },
	{ path: "/vendor-status", component: VendorStatus },
	{ path: "/vendor-entries/:path", component: VendorEntries },
	{ path: "/vendor-entries", component: VendorEntries },
	{ path: "/vendor-listing", component: VendorListing },
	// { path: "/testing", component: TestingPage },
	{ path: "/account-entries", component: AccountEntries },
	{ path: "/forget-password", component: forgetPassword },
	{ path: "/update-password", component: PageUpdatePassword },
	{ path: "/map", component: ListingCarMapPage },
	{ path: "/dashboard", component: App },
];

const Routes = () => {
	return (
		<BrowserRouter basename="/">
			<Switch>
				<Route path="/dashboard" component={App} />
				<Route path="/" component={Client} />
			</Switch>
		</BrowserRouter>
	);
};

const Client = () => {
	return (
		<>
			<ScrollToTop />
			<Header />
			<RouteChangeTracker />
			<Switch>
				{pages.map(({ component, path, exact }) => {
					return (
						<Route
							key={path}
							component={component}
							exact={!!exact}
							path={path}
						/>
					);
				})}
				<Route component={Page404} />
			</Switch>
			<Footer />
		</>
	);
};

export default Routes;
